import * as React from "react";

import {withRouter} from "react-router";
import AbonentLogs from "./AbonentLogs";

class AbonentLogsParams extends React.Component{

    render() {
        return (
            <AbonentLogs
                {...this.props}
                qs = {this.props.location.pathname}
            />
        );
    }
}

export default withRouter(AbonentLogsParams);